import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { resolveIcon } from "@/cms/icons";

/** Long-form legal/policy layout: dark header, then one white card per
 * section. Each line of a section's body renders as its own paragraph, so
 * admins can edit a policy as plain text. */
export default function PolicyDocument({ fields = {} }) {
  const navigate = useNavigate();
  const { icon, eyebrow, title, dateline, intro, sections = [] } = fields;
  const Icon = resolveIcon(icon);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-[#0B2421]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="flex items-center gap-1.5 text-white/60 hover:text-white text-sm mb-6 transition-colors"
          >
            <ChevronLeft className="h-4 w-4" />
            Back
          </button>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-xl bg-[#D4AF37]/20 flex items-center justify-center">
              <Icon className="h-5 w-5 text-[#D4AF37]" />
            </div>
            {eyebrow && (
              <p className="text-[#D4AF37] text-xs font-semibold uppercase tracking-widest">
                {eyebrow}
              </p>
            )}
          </div>
          <h1 className="text-white font-bold text-3xl sm:text-4xl mb-2">{title}</h1>
          {dateline && <p className="text-white/50 text-sm">{dateline}</p>}
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {intro && (
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 sm:p-8 mb-6">
            <p className="text-gray-600 leading-relaxed whitespace-pre-line">{intro}</p>
          </div>
        )}

        <div className="space-y-4">
          {sections.map((section, i) => (
            <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 sm:p-8">
              <h2 className="text-[#0B2421] font-bold text-lg mb-4">{section.title}</h2>
              <div className="space-y-2">
                {(section.body || "")
                  .split("\n")
                  .filter((line) => line.trim())
                  .map((line, j) => (
                    <p key={j} className="text-gray-600 text-sm leading-relaxed">{line}</p>
                  ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-400 text-xs mt-8 pb-8">
          © {new Date().getFullYear()} Exqura Golf & Experiences. All rights reserved.
        </p>
      </div>
    </div>
  );
}
